<div class="modol_comp">
  <div class="modal-header pb-0 pt-0 d-flex">
    <button class="button-close" mat-button [mat-dialog-close]="false">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
        <path
          d="M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm121.6 313.1c4.7 4.7 4.7 12.3 0 17L338 377.6c-4.7 4.7-12.3 4.7-17 0L256 312l-65.1 65.6c-4.7 4.7-12.3 4.7-17 0L134.4 338c-4.7-4.7-4.7-12.3 0-17l65.6-65-65.6-65.1c-4.7-4.7-4.7-12.3 0-17l39.6-39.6c4.7-4.7 12.3-4.7 17 0l65 65.7 65.1-65.6c4.7-4.7 12.3-4.7 17 0l39.6 39.6c4.7 4.7 4.7 12.3 0 17L312 256l65.6 65.1z" />
      </svg>
    </button>
  </div>

  <!-- Image -->
  <div class="image-container mb-2" *ngIf="mediaType === 'image'">
    <img #contentToCapture id="image" [src]="mediaUrl" alt="">
  </div>

  <!-- PDF Preview -->
  <div class="image-container mb-2" *ngIf="mediaType === 'pdf'">
    <img #contentToCapture id="image" [src]="pdfBackgroundImage" alt="">
  </div>

  <!-- Video Player -->
  <div class="video-container mb-2" *ngIf="mediaType === 'video'">
    <video #videoPlayer controls controlsList="nodownload" [src]="mediaUrl" preload="metadata">
      Your browser does not support the video tag.
    </video>
  </div>

  <!-- Buttons -->
  <div class="button-container" *ngIf="!fromHelpSupport">

    <ng-container *ngIf="mediaType === 'image'">
      <button id="downloadButton" type="button" class="btn pdf mx-1" (click)="downloadImage()">Download</button>
      <button type="button" class="btn pdf mx-1" (click)="downLoadImage()">Print to PDF</button>
    </ng-container>

    <ng-container *ngIf="mediaType === 'pdf'">
      <a [href]="mediaUrl">Download PDF</a>
    </ng-container>

    <ng-container *ngIf="mediaType === 'video'">
      <a [href]="mediaUrl" [download]="fileName" type="button" class="btn pdf mx-1">Download Video</a>
    </ng-container>

  </div>
</div>
